var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M8.448 10.42l-.326-.324a5.29 5.29 0 01-.802-6.5l7.67 7.62a5.38 5.38 0 01-6.542-.796zm9.002 1.425a7.392 7.392 0 01-5.833 2.122l.73 5.077h1.15c.56 0 1.014.452 1.014 1.008a1.01 1.01 0 01-1.014 1.008H3.35c-.56 0-1.015-.45-1.015-1.008 0-.556.454-1.008 1.015-1.008h1.225l1.846-7.79.002-.009a7.296 7.296 0 01.264-10.091.741.741 0 011.044 0l4.067 4.04.474-.47a1.02 1.02 0 011.435 0 1.003 1.003 0 010 1.426l-.474.47 4.216 4.188a.73.73 0 010 1.037zm-10.79 7.2h3.637l-.774-5.383-1.42-.706-1.443 6.088z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMention);
export default __webpack_public_path__ + "static/media/mention.3de8a468f89aa363aa0be3aa322353e9.svg";
export { ForwardRef as ReactComponent };